/* eslint-disable */
import axios from '@/services/axios'

export default {
    createUser(data) {
        return axios.post("/users/createUser", data);
    },
    deleteUser(data) {
        return axios.post("/users/deleteUser", data);
    },

    priceListSetting(search) {
        return axios.get("/setting/priceListSetting", {
            params: search
        });
    },

    perList(){
        return axios.get("/setting/perList");
    },

    getPrice(search){
        return axios.get("/setting/getPrice", {
            params: search
        });
    },
    updatePrice(data) {
        return axios.post("/setting/updatePrice", data);
    },

    deletePrice(data) {
        return axios.post("/setting/deletePrice", data);
    },

    addPrice(data) {
        return axios.post("/setting/addPrice", data);
    },


    seedList(search) {
        return axios.get("/setting/seedList", {
            params: search
        });
    },

    getSeed(search){
        return axios.get("/setting/getSeed", {
            params: search
        });
    },
    addSeed(data) {
        return axios.post("/setting/addSeed", data);
    },
    updateSeed(data) {
        return axios.post("/setting/updateSeed", data);
    },
    deleteSeed(data) {
        return axios.post("/setting/deleteSeed", data);
    },


    keywordList(search) {
        return axios.get("/setting/keywordList", {
            params: search
        });
    },
    addKeyword(data) {
        return axios.post("/setting/addKeyword", data);
    },
    deleteKeyword(data) {
        return axios.post("/setting/deleteKeyword", data);
    },
    updateKeyword(data) {
        return axios.post("/setting/updateKeyword", data);
    },


    synonymList(search) {
        return axios.get("/setting/synonymList", {
            params: search
        });
    },
    getSynonymByKeyword(data){
        return axios.post("/setting/getSynonymByKeyword", data);
    },
    addSynonym(data) {
        return axios.post("/setting/addSynonym", data);
    },
    updateSynonym(data) {
        return axios.post("/setting/updateSynonym", data);
    },
    deleteSynonym(data) {
        return axios.post("/setting/deleteSynonym", data);
    },



    uncategorizedList(search) {
        return axios.get("/setting/uncategorizedList", {
            params: search
        });
    },

    getPropGroupList() {
        return axios.get("/setting/getPropGroupList");
    },

    getPropList(prop_group) {
        return axios.get(`/setting/getPropList/${prop_group}`);
    },

    insPropCls(data) {
        return axios.post("/setting/insPropCls", data);
    },

    insIgnoreToken(data) {
        return axios.post("/setting/insIgnoreToken", data);
    },
};
